import { Link } from 'react-router-dom';
import { Waves } from 'lucide-react';
import { useSidebar } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';

export function AppLogo() {
  const { state } = useSidebar();
  return (
     <Link
        to="/"
        className="flex items-center gap-2.5 text-foreground transition-colors hover:text-primary"
      >
        <Waves className="size-8 min-w-8 text-primary" />
        <span
          className={cn("text-xl font-semibold", 
            state === 'collapsed' && 'hidden'
          )}>
          Loch & Lunge
        </span>
      </Link>
  )
}
